import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../../utils/tpoGenQueryKeys';
import { sendNotification } from 'utils/helperMethods';

const deleteAllPromotions = async (planId: string) => {
    const token = localStorage.getItem('accessToken');
    const response = await axios(tpoGenUrls.deleteAllPromos(planId), {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

const useDeleteAllPromotionsMutation = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation({
        mutationFn: (planId: string) => deleteAllPromotions(planId),
        onSuccess: () => {
            queryClient.removeQueries({ queryKey: [...tpoGenKeys.all, 'planning-groups'] });
            queryClient.removeQueries({ queryKey: [...tpoGenKeys.all, 'plan-list'] });
            queryClient.invalidateQueries({ queryKey: ['calendarData'] });
            sendNotification('success', 'All promotions deleted successfully');
            onSuccess?.();
        },
        onError: (error: any) => {
            const message =
                error?.response?.data?.detail ||
                error?.response?.data?.message ||
                error?.message ||
                'Failed to delete all promotions';
            sendNotification('error', message);
        },
    });
    return { mutateAsync, isPending };
};

export default useDeleteAllPromotionsMutation;
